import { enUS as en, ru } from 'date-fns/locale';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { TimeField, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { withControl } from '@features/effector-form/hoc/withControl';
import { getSafePickerLocale } from '@shared/utils/getSafePickerLocale';

const EN = 'en';
const LNG = localStorage.getItem('lang') || EN;

export const TimeControl = withControl(
  ({
    value,
    setValue,
    error,
    label,
    required,
    readOnly,
    disabled,
    isError,
    helperText,
  }) => (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={LNG === EN ? en : ru}
      localeText={getSafePickerLocale(LNG)}
    >
      <FormControl required={required && !readOnly} disabled={disabled}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <TimeField
          value={value}
          onChange={(newValue) => setValue(newValue)}
          InputProps={{
            readOnly,
            disabled,
            error: isError,
          }}
          readOnly={readOnly}
          disabled={disabled}
          size="small"
          format="HH:mm"
        />
        {error && <FormHelperText error>{error}</FormHelperText>}

        {!readOnly && helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </LocalizationProvider>
  )
);
